import Connecting from './connecting.webp';
import Gameplay from './gameplay.webp';
import Painting from './painting.webp';
import Title from './Title.webp';

export default {
    Connecting,
    Gameplay,
    Painting,
    Title
}